import { nanoid } from 'nanoid';

export const getRandomString = (length = 12) => nanoid(length);
